import React from "react";

import PaymentOptionCard from "../PaymentOptionCard";

import styles from "./PaymentOptionsView.module.scss";
import { ReactComponent as StripeLogo } from "assets/icons/stripe_s_logo.svg";

interface PaymentOptionsViewProps {
  isStripeConnected: boolean;
  selectedProvider: string;
  onSelectProvider: (provider: string) => void;
}

const PaymentOptionsView: React.FC<PaymentOptionsViewProps> = ({
  isStripeConnected,
  selectedProvider,
  onSelectProvider,
}) => {
  return (
    <div className={styles.container}>
      <PaymentOptionCard
        logo={<StripeLogo className={styles.stripeLogo} />}
        label="Stripe"
        isConnected={isStripeConnected}
        selected={selectedProvider === "stripe"}
        onClick={() => onSelectProvider("stripe")}
      />
      <div className={styles.placeHolder}>more to come...</div>
    </div>
  );
};

export default PaymentOptionsView;
